import React, { Component } from 'react';
import { DropdownButton } from 'react-bootstrap';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import Select from './Select';
import InputRange from 'react-input-range';
import Button from '../common/Button';
import { isEmpty, map, range, find } from 'lodash';

class FilterBy extends Component {
  constructor(props) {
    super(props);
    if (props.filterState) {
      this.state = props.filterState;
    } else {
      this.state = {
        distValue: { min: 0, max: 50, userSelected: false },
        toggleSwitchVal: false,
        fiterBy: false,
        clearAll: false,
        selectedMake: '',
        selectedModel: '',
        selectedYear: '',
        filterParams: ''
      };
    }
  }
  componentWillMount() {
    this.props.actions.getManufacturers();
  }
  switch() {
    this.setState({ toggleSwitchVal: !this.state.toggleSwitchVal, clearAll: false })
  }
  clearField() {
    this.setState({
      distValue: { min: 0, max: 50, userSelected: false },
      toggleSwitchVal: false,
      clearAll: true,
      selectedMake: '',
      selectedModel: '',
      selectedYear: '',
      filterParams: ''
    });
    this.props.filterApplied && this.props.filterApplied('', this.state);
  }

  render() {
    const { filterApplied, jobRequestReducer } = this.props;

    let startYear = 1990;
    let endYear = (new Date()).getFullYear();
    let years = [];
    let year = startYear;
    map(range(endYear - startYear + 2), () => {
      years.push(year);
      year = year + 1;
    });
    let carMakeAndModels = jobRequestReducer && jobRequestReducer.carMakeAndModels && jobRequestReducer.carMakeAndModels.length ? jobRequestReducer.carMakeAndModels : [];
    let carMakeNames = carMakeAndModels.map(a => a.name);

    let selecteCarMake = find(carMakeAndModels, { name: this.state.selectedMake });
    // let carModelLoaded = selecteCarMake && selecteCarMake.isCarModelLoaded;
    let carModelNames = selecteCarMake && selecteCarMake.carmodel && selecteCarMake.carmodel.map(a => a.name);

    return (
      <div className="fiter-dropdown inline-disp" onClick={this.props.mapVisible}>
        <DropdownButton open={this.state.fiterBy} bsSize="small" id="dropdown-size-small" onToggle={(e) => { this.setState({ fiterBy: e }); }} noCaret title={
          <span className="holder">
            <i className={this.state.filterParams ? "mdi mdi-filter-variant pull-left active" : "mdi mdi-filter-variant pull-left"} />
            <label>Filter by</label>
            <i className={this.state.fiterBy ? "mdi mdi-chevron-up pull-right" : "mdi mdi-chevron-down pull-right"} />
          </span>
        } >
          <div className="holder">
            <h5 className="title">Job priority</h5>
            <div className="content">
              <span className="text">Only Show Urgent</span>
              <span className="toggle-switch toggleBtn">
                <ToggleSwitch
                  checked={this.state.toggleSwitchVal}
                  size="small"
                  onChange={this.switch.bind(this)}
                  ref={(node) => {
                    this.toggleSwitch = node;
                  }} />
              </span>
            </div>
          </div>
          <div className="holder">
            <h5 className="title">Car</h5>
            <Select onChange={(e) => {
              this.setState({ selectedMake: e, selectedModel: '', selectedYear: '' });
              let make = find(carMakeAndModels, { name: e });
              make && this.props.actions.getCarModels(make.id);
            }} data={carMakeNames && carMakeNames.length ? carMakeNames : []} title={this.state.selectedMake == '' ? "Select Brand" : this.state.selectedMake} clearAll={this.state.clearAll} />
            <Select disabled={this.state.selectedMake && carModelNames && carModelNames.length ? false : true} title={this.state.selectedModel == '' ? "Select Model" : this.state.selectedModel} onChange={(e) => { this.setState({ selectedModel: e, selectedYear: '' }); }} data={carModelNames} clearAll={this.state.clearAll} />
            <Select disabled={this.state.selectedModel && years && years.length ? false : true} title={this.state.selectedYear == '' ? "Select Year" : this.state.selectedYear} onChange={(e) => { this.setState({ selectedYear: e }); }} data={years} clearAll={this.state.clearAll} />
          </div>
          <div className="holder">
            <h5 className="title">Distance</h5>
            <div className="content">
              <InputRange
                formatLabel={distValue => `${distValue}km`}
                maxValue={50}
                minValue={0}
                value={this.state.distValue}
                onChange={distValue =>{
                  let updatedDistance = distValue;
                  updatedDistance.userSelected = true;
                   this.setState({ 'distValue':updatedDistance, clearAll: false })
                  }} />
              <span className="range-min">{`${this.state.distValue.min} km`}</span>
              <span className="range-max">{`${this.state.distValue.max} km`}</span>
            </div>
          </div>
          <div className="holder footer">
            <a onClick={this.clearField.bind(this)}>Clear</a>
            <Button btnType="red" btnSize="sm" fontSize={13} label="Apply" btnCallBack={() => {
              let queryParams = '';
              if (this.state.toggleSwitchVal) {
                queryParams = queryParams + '&onlyurgent=1';
              }
              if (this.state.selectedMake) {
                queryParams = queryParams + '&brand=' + this.state.selectedMake;
              }
              if (this.state.selectedModel) {
                // let selectedModelId = '';
                // selecteCarMake && selecteCarMake.carmodel && selecteCarMake.carmodel.map((a) => {
                //   if (this.state.selectedModel == a.name) {
                //     selectedModelId = a.id;
                //   }
                // });
                queryParams = queryParams + '&model=' + this.state.selectedModel;
              }
              if (this.state.selectedYear) {
                queryParams = queryParams + '&year=' + this.state.selectedYear;
              }
              if (!isEmpty(this.state.distValue)) {
                let distanceSelected = this.state.distValue && this.state.distValue.userSelected ? this.state.distValue.max : 0;
                queryParams = queryParams + '&distance=' + distanceSelected;
              }
              this.setState({ fiterBy: false, filterParams: queryParams });
              filterApplied && filterApplied(queryParams, this.state);
            }} />
          </div>
        </DropdownButton>
      </div>
    );
  }
}

export default FilterBy;



// WEBPACK FOOTER //
// ./src/components/Results/FilterBy.jsx